import React from 'react';
import classNames from 'classnames';

import BaseIcon, { IconSize } from '@components/base-icon/base-icon';
import ErrorIcon from '@nerdwallet/react-icon/material/PriorityHigh';

import styles from './institution-icon.module.scss';

export { IconSize as ICON_SIZE };

type Props = {
  altText: string; // Image alt text for accessibility
  iconSize?: IconSize;
  isInError?: boolean; // If true, error icon is displayed
  isEnabled?: boolean; // If false, icon is grayed out
  src: string; // Image URL for the icon, typically from getCustomOrGenericIconForAccount()
};

/**
 * Icon for a financial institution
 */
const InstitutionIcon = ({
  altText,
  isEnabled = true,
  isInError = false,
  iconSize = IconSize.SMALL,
  src,
}: Props) => {
  return (
    <div
      className={classNames(styles.container, !isEnabled && styles.disabled)}
    >
      <BaseIcon src={src} altText={altText} size={iconSize} />
      {isInError && <ErrorIcon color="white" className={styles.bubble} />}
    </div>
  );
};

export default InstitutionIcon;
